module.exports = __webpack_public_path__ + "static/media/nh.c336adc3.svg";